import { api } from 'shared/api';

const passwordApi = api.injectEndpoints({
    endpoints: build => ({
        changePassword: build.mutation<unknown, { oldPassword: string, newPassword: string }>({
            query: ({ oldPassword, newPassword }) => {
                const formData = new FormData();
                formData.append('oldPassword', oldPassword);
                formData.append('newPassword', newPassword);
                return {
                    url: `/user/change-password`,
                    method: 'POST',
                    body: formData
                };
            }
        }),
    })
});

export const { useChangePasswordMutation } = passwordApi;

export default passwordApi;
